export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
       // options
            , allEventsLink: false
            , hasImages: false
            , imageBackground: false
            , buyNowButton: {visible: true, text: 'Buy Now'}
            , moreButton: {visible: false, text: 'MORE >'}
            , maxItemsVisible: 5
            , isResponsive: false
    				, hasDescription: true
            , textContainer: true
            , link: 'buttons' //options are 'all', 'text', 'image', 'imageAndText', or ''
            , attributeOrder: {
              1: 'image',
              2: 'title',
              3: 'date',
              4: 'description',
              5: 'buttons'
      }
    , multiFeatureLoaded: function(data){
              $('.all-events-btn').text('VIEW All Events').wrap('<div class="event-btn-wrap"></div>');
              // use function below if "more" text needs to appear at end of description text
 console.log(data);
             $('#multiScheduleFeature .featureItem').each(function(i, value) {		  
				var dataItem = data[i];
                var itemDescripton = $(this).find('.featureItemDescription');
				var buyNowButton = $(this).find('.button-container .buy-now-button');				
				if(dataItem.Purchaseable)
					$(buyNowButton).show();
				  else
					$(buyNowButton).hide();
                var itemDescripton = $(this).find('.featureItemDescription');
                var itemTitle = $(this).find('.featureItemTitle');
 const eventDate = $(this).find($('span.featureItemDate'));
          const dateYear = eventDate.text().slice(-4);
          const dateMonth = eventDate.text().slice(0, 3);
          const dateDay = eventDate.text().slice(4, 7).replace(',', '');

          eventDate.text(dateMonth);
          eventDate.append(`<span class='day'>${dateDay}</span>`);
          eventDate.append(`<p class='year'>${dateYear}</p>`);
                // // uncomment below if you need to limit the characters in the description text
                 /*var characterLimit =30;
                 var itemDescriptonText = itemDescripton.text();
                  if ( itemDescriptonText.length > characterLimit ) {
                  var trimmedText = itemDescriptonText.substring(0,characterLimit) ;
                     itemDescripton.text(trimmedText);
                 }*/

                var titleLimit = 30;
                 var itemTitleText = itemTitle.text();
                 if ( itemTitleText.length > titleLimit ) {
                   var trimmedText = itemTitleText.substring(0,titleLimit);
                   itemTitle.text(trimmedText);
                }
				
				

              });
            }
  });

};

